<div class="emds">
  <div class="modal-default" id="{{Id}} + 'confirm'">
    <div *ngIf="!modalData.hideHeader" class="modal-header">
      <span translate>{{modalData.modalTitleText}}</span>
    </div>
    <div class="modal-body"
      [innerHTML]="modalData.bodyText | safeHtml">
    </div>
    <div class="modal-footer">
      <button id="{{Id}} + '-yes-button'" class="btn btn-primary yes-btn" (click)="yesSelected()" translate>{{modalData.yesButtonText}}</button>
      <button *ngIf="!modalData.hideNoButton" id="{{Id}} + '-no-button'" class="btn btn-light no-btn" (click)="noSelected()" translate>{{modalData.noButtonText}}</button>
    </div>
  </div>
</div>
